import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'actions';
import { CardHeader, CardContent, Divider, Card, Alert } from '@mui/material';
import { FilesDropzone } from 'components';

import ModalDialog from '../../../../components/ModalDialog/ModalDialog.js';

const FailuresHelixDialog = (props) => {
	const { open, onClose, ...rest } = props;
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);

	return (
		<ModalDialog
			maxWidth="md"
			onClose={onClose}
			open={open}
			title="Helix Incident"
			hasConfirm={false}
			cancelLabel="Close"
		>
			<h3>Connection to Helix not configured!</h3>
		</ModalDialog>
	);
};

FailuresHelixDialog.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default FailuresHelixDialog;
